/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import InstagramApi from 'scripts/social/instagram';
import template from './instagram-card.stache';
import 'dotdotdot';

const POST_URL_REG_EXP = /https?:\/\/(www.)?instagram\.com\/p\/([^\/\?#]+)/gi;

Component.extend({
    tag: 'instagram-card',
    template: template,
    viewModel: {
        define: {
            socialId: {
                type: 'string',
                value: null,
            },
            authorId: {
                type: 'string',
                value: null,
            },
        },
    },
    events: {
        inserted: function() {
            let socialID = this.parsePostUrl();
            if (socialID) {
                this.viewModel.attr('socialId', socialID);
                InstagramApi.getDataWithCallback(
                    { socialID },
                    this.handleReceiveData.bind(this),
                );
            }
        },

        parsePostUrl: function() {
            if (this.viewModel.attr('postUrl')) {
                let regexp = new RegExp(POST_URL_REG_EXP);
                let hrefArr = regexp.exec(this.viewModel.attr('postUrl'));
                return hrefArr && hrefArr[2] ? hrefArr[2] : null;
            } else {
                return null;
            }
        },

        handleReceiveData(data) {
            const { author_id } = data;
            if (author_id) {
                this.viewModel.attr('authorId', author_id);

                InstagramApi.getUserDataWithCallback(
                    author_id,
                    this.handleReceiveUserData.bind(this),
                );
            }

            this.setData(data);
            this.initDotDotDot();
        },

        handleReceiveUserData(data) {
            this.setUserData(data);
        },

        setData(data) {
            const { author_name = 'usopengolf', thumbnail_url, title } = data;
            this.viewModel.attr('author', author_name);
            this.viewModel.attr('thumbnailUrl', thumbnail_url);
            this.viewModel.attr('title', title);

            this.viewModel.attr('postData', data);
        },

        setUserData(data) {
            const { profile_pic_url } = data;
            this.viewModel.attr('authorPicUrl', profile_pic_url);
        },

        initDotDotDot() {
            this.element
                .find(
                    '.s-video-landing-slider-item__text.s-video-landing-slider-item__text--cut',
                )
                .dotdotdot();
        },
    },
});
